import React from "react";

const LineSvg = ({ width }) => {
  return (
    <svg
      preserveAspectRatio="none"
      viewBox="0 0 767 97"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g opacity="0.2">
        <path
          d="M767.001 0L761.799 0.131448V0.151672L767.001 0Z"
          fill="#1D1D1B"
        />
        <path
          d="M751.459 0.71875L741.285 1.79058L741.327 1.87148L751.479 0.779421L751.459 0.71875Z"
          fill="#1D1D1B"
        />
        <path
          d="M731.383 3.37891C728.145 3.99572 724.99 4.69342 721.899 5.48212L722.045 5.62369C725.095 4.83498 728.249 4.11705 731.467 3.49013L731.383 3.37891Z"
          fill="#1D1D1B"
        />
        <path
          d="M712.935 8.05859L704.537 11.0415L704.83 11.2134L713.165 8.22038L712.935 8.05859Z"
          fill="#1D1D1B"
        />
        <path
          d="M696.641 14.3398L689.183 17.8688L689.642 18.071L697.017 14.532L696.641 14.3398Z"
          fill="#1D1D1B"
        />
        <path
          d="M682.102 21.5586L675.271 25.3707L675.856 25.6032L682.604 21.7811L682.102 21.5586Z"
          fill="#1D1D1B"
        />
        <path
          d="M668.605 29.2422L662.067 33.1554L662.777 33.4385L669.253 29.495L668.605 29.2422Z"
          fill="#1D1D1B"
        />
        <path
          d="M655.55 37.0898L649.032 41.0233L649.847 41.3367L656.302 37.3831L655.55 37.0898Z"
          fill="#1D1D1B"
        />
        <path
          d="M642.472 44.9258L635.829 48.8087L636.685 49.1423L643.308 45.2595L642.472 44.9258Z"
          fill="#1D1D1B"
        />
        <path
          d="M629.101 52.6406L622.228 56.4224L623.085 56.7965L629.937 52.9945L629.101 52.6406Z"
          fill="#1D1D1B"
        />
        <path
          d="M615.229 60.1445L608.085 63.8049L608.941 64.1993L616.086 60.5288L615.229 60.1445Z"
          fill="#1D1D1B"
        />
        <path
          d="M600.795 67.3828L593.274 70.8511L594.131 71.296L601.651 67.8075L600.795 67.3828Z"
          fill="#1D1D1B"
        />
        <path
          d="M585.482 74.1797L577.418 77.3446L578.212 77.8401L586.317 74.6448L585.482 74.1797Z"
          fill="#1D1D1B"
        />
        <path
          d="M569.082 80.3359L560.496 83.1571L561.227 83.7031L569.855 80.8617L569.082 80.3359Z"
          fill="#1D1D1B"
        />
        <path
          d="M551.619 85.7656L542.511 88.152L543.138 88.7587L552.309 86.342L551.619 85.7656Z"
          fill="#1D1D1B"
        />
        <path
          d="M533.11 90.2969L523.479 92.1473L523.981 92.8046L533.674 90.9238L533.11 90.2969Z"
          fill="#1D1D1B"
        />
        <path
          d="M513.618 93.6758L503.548 94.8487L503.841 95.5565L514.015 94.3634L513.618 93.6758Z"
          fill="#1D1D1B"
        />
        <path
          d="M493.311 95.6172L482.991 95.9408L483.033 96.689L493.479 96.3452L493.311 95.6172Z"
          fill="#1D1D1B"
        />
        <path
          d="M472.652 95.8282L462.291 95.4844L462.144 96.2529L472.569 96.5865L472.652 95.8282Z"
          fill="#1D1D1B"
        />
        <path
          d="M451.97 94.9364L441.712 94.168L441.42 94.9466L451.761 95.715L451.97 94.9364Z"
          fill="#1D1D1B"
        />
        <path
          d="M431.559 93.1387L421.552 91.8242L421.071 92.6129L431.183 93.9173L431.559 93.1387Z"
          fill="#1D1D1B"
        />
        <path
          d="M411.733 90.2346L402.145 88.3438L401.434 89.1122L411.148 91.0132L411.733 90.2346Z"
          fill="#1D1D1B"
        />
        <path
          d="M392.808 86.1713L383.72 83.7344L382.822 84.4826L391.993 86.9297L392.808 86.1713Z"
          fill="#1D1D1B"
        />
        <path
          d="M374.905 81.0845L366.319 78.2734L365.254 79.0015L373.923 81.8226L374.905 81.0845Z"
          fill="#1D1D1B"
        />
        <path
          d="M357.856 75.34L349.458 72.3672L348.351 73.1053L356.749 76.0782L357.856 75.34Z"
          fill="#1D1D1B"
        />
        <path
          d="M346.589 70.9425C343.748 69.9617 340.928 68.9808 338.17 68L337 68.7483C339.82 69.7493 342.661 70.72 345.482 71.6907L346.589 70.9425Z"
          fill="#1D1D1B"
        />
        <path
          d="M336.32 68.0117L329.154 71.6418L330.303 72.1979L337.531 68.5476L336.32 68.0117Z"
          fill="#1D1D1B"
        />
        <path
          d="M321.612 75.0898L313.695 78.3256L314.656 78.9222L322.678 75.6662L321.612 75.0898Z"
          fill="#1D1D1B"
        />
        <path
          d="M305.316 81.2656L300.929 82.57L296.396 83.7935L297.127 84.4407L301.681 83.2172L306.173 81.8926L305.316 81.2656Z"
          fill="#1D1D1B"
        />
        <path
          d="M287.227 86.1719L277.951 88.4268L278.599 89.0739L287.916 86.819L287.227 86.1719Z"
          fill="#1D1D1B"
        />
        <path
          d="M268.528 90.5391L258.94 92.4502L259.441 93.0973L269.113 91.1761L268.528 90.5391Z"
          fill="#1D1D1B"
        />
        <path
          d="M249.142 94.0898C245.841 94.5752 242.499 94.9898 239.115 95.3032L239.365 95.9605C242.812 95.6572 246.197 95.2325 249.539 94.7471L249.142 94.0898Z"
          fill="#1D1D1B"
        />
        <path
          d="M228.858 95.807L218.497 95.7969L218.434 96.4339L228.9 96.4642L228.858 95.807Z"
          fill="#1D1D1B"
        />
        <path
          d="M208.197 95.3103C204.792 95.0576 201.408 94.7239 198.065 94.2891L197.731 94.8856C201.115 95.3306 204.541 95.6744 207.988 95.9373L208.197 95.3103Z"
          fill="#1D1D1B"
        />
        <path
          d="M188.288 92.6919C185.092 92.065 182 91.3269 178.992 90.5078L178.386 91.0235C181.415 91.8628 184.57 92.611 187.808 93.2481L188.288 92.6919Z"
          fill="#1D1D1B"
        />
        <path
          d="M170.343 87.7686C167.585 86.7675 164.953 85.6856 162.425 84.543L161.61 84.9575C164.138 86.1204 166.812 87.2226 169.612 88.2337L170.343 87.7686Z"
          fill="#1D1D1B"
        />
        <path
          d="M155.281 80.9249L148.763 77.0117L147.865 77.3353L154.404 81.2889L155.281 80.9249Z"
          fill="#1D1D1B"
        />
        <path
          d="M142.746 72.9169C140.803 71.5316 138.756 70.1564 136.771 68.7812L135.894 69.0846C137.879 70.4598 139.905 71.8249 141.848 73.2203L142.746 72.9169Z"
          fill="#1D1D1B"
        />
        <path
          d="M130.463 64.7438L123.757 60.8711L123.026 61.1846L129.627 65.0674L130.463 64.7438Z"
          fill="#1D1D1B"
        />
        <path
          d="M116.613 57.1817L108.926 53.7539L108.382 54.0674L115.966 57.4952L116.613 57.1817Z"
          fill="#1D1D1B"
        />
        <path
          d="M100.631 50.6704C97.7688 49.7098 94.7816 48.8301 91.7106 48.0312L91.3763 48.3245C94.4264 49.1233 97.3511 50.0131 100.192 50.9737L100.631 50.6704Z"
          fill="#1D1D1B"
        />
        <path
          d="M82.2061 45.9386C78.9471 45.3319 75.6255 44.8263 72.2412 44.4219L72.1158 44.6747C75.4583 45.0892 78.759 45.6049 81.9762 46.2217L82.2061 45.9386Z"
          fill="#1D1D1B"
        />
        <path
          d="M62.0039 43.449C58.5569 43.2165 55.0891 43.085 51.6004 43.0547V43.2468C55.0683 43.2873 58.5152 43.4288 61.9413 43.6715L62.0039 43.449Z"
          fill="#1D1D1B"
        />
        <path
          d="M41.1764 43.2695C37.7085 43.4414 34.2825 43.7144 30.8773 44.0886L30.9399 44.2099C34.3242 43.8358 37.7503 43.583 41.1973 43.4212L41.1764 43.2695Z"
          fill="#1D1D1B"
        />
        <path
          d="M20.9335 45.582C17.6954 46.1988 14.5618 46.9471 11.6162 47.847L11.6789 47.8875C14.6245 47.0078 17.758 46.2696 20.9961 45.6629L20.9335 45.582Z"
          fill="#1D1D1B"
        />
        <path
          d="M3.40585 51.0117L0.000660879 52.9228L3.42676 51.0218L3.40585 51.0117Z"
          fill="#1D1D1B"
        />
      </g>
    </svg>
  );
};

export default LineSvg;
